export const aciForbidden = {
    iconName: 'forbidden',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                d: 'M8 12h8M2 12a10 10 0 1020 0 10 10 0 00-20 0z',
                stroke: 'currentColor',
                'stroke-width': '1.215',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
